import { render, staticRenderFns } from "./InputFecha.vue?vue&type=template&id=38f62d08&"
import script from "./InputFecha.vue?vue&type=script&lang=js&"
export * from "./InputFecha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports